import axios from 'axios';
import {getAuthHeader} from  '../global_helpers/authHeader.js';
import {getTPAID} from  '../global_helpers/sessionReturn.js';


const state = {
    globalContext: {
        userContext: {
            id: "",
            name: "",
            email: "",
            title: "",
            is_staff: "",
            is_active: "",
            date_joined: "",
            is_signer: "",
            settings: "",
            token: ""
        },
        
        tpaContext: {
            id: "",
            name:"",
            settings: ""
        },
        
        templatesContext: [
            {   
                property: {
                    duration: 3
                },
                proposal: {
                    hasDefault: false,
                    default: {}
                },
                agreement: {
                    hasDefault: false,
                    default: {}
                }
            },
            {
                property: {
                    duration: 5
                },
                proposal: {
                    hasDefault: false,
                    default: {}
                },
                agreement: {
                    hasDefault: false,
                    default: {}
                }
            }
        ],

        listsContext: {
            agreementTemplates: {
                3: {
                    starter: [],
                    default: []
                },
                5: {
                    starter: [],
                    default: []
                }
            },
            proposalTemplates: {
                3: {
                    starter: [],
                    default: []
                },
                5: {
                    starter: [],
                    default: []
                }
            },
            durations: []
        }
    }
};

const getters = {
    globalContext: (state) => state.globalContext,
};

const actions = {
    async fetchAllTPAGlobalContext({commit, dispatch}){
        let authHeader = getAuthHeader();
        let tpa_id = getTPAID();
        axios.get("/global/?all=true&entity_type=tpa&entity_id="+tpa_id, authHeader)
        
        .then((res) => {
            dispatch('getTpa', {root: true});
            commit('setAllGlobalContext', res.data);
        })
        .catch(err => {
            console.log(err);
            dispatch('raiseMessage', "There was an error loading your company's settings!", {root: true});
        });
    },
   
};

const mutations = {
    setAllGlobalContext(state, data){
        state.globalContext = data.globalContext;
    },
    
    setTemplatesContext(state, data){
        state.globalContext.templatesContext = data.globalContext.templatesContext
    },
    
    setListsContext(state, data){
        state.globalContext.listsContext = data.globalContext.listsContext
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};